import { render, staticRenderFns } from "./MBGeneralView.vue?vue&type=template&id=2bbe3b58&scoped=true&class=fill-height"
import script from "./MBGeneralView.vue?vue&type=script&lang=ts"
export * from "./MBGeneralView.vue?vue&type=script&lang=ts"
import style0 from "./MBGeneralView.vue?vue&type=style&index=0&id=2bbe3b58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe3b58",
  null
  
)

export default component.exports